const add_comma = (num) =>
{
  if (num === undefined) num = '';
  var regexp = /\B(?=(\d{3})+(?!\d))/g;
  return num.toString().replace(regexp, ',');
}

export default add_comma;